import { motion } from "framer-motion";
import { Mail, ArrowRight, ShieldCheck } from "lucide-react";

export default function Contact() {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative bg-[#F4F4F5] py-24 md:py-40"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    className="relative rounded-3xl bg-zinc-950 text-white overflow-hidden p-10 md:p-20"
                >
                    {/* Ambient */}
                    <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#FF5500] opacity-15 blur-[160px] pointer-events-none" />
                    <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#3B82F6] opacity-10 blur-[160px] pointer-events-none" />

                    <div className="relative z-10 grid grid-cols-1 md:grid-cols-12 gap-10">
                        <div className="md:col-span-7">
                            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5500]">
                                005 // Contact
                            </span>
                            <h2 className="mt-6 font-display font-black text-5xl md:text-7xl leading-[0.9] tracking-tight">
                                Build the<br />
                                <span className="italic font-light">post-scarcity</span><br />
                                future with us.
                            </h2>
                            <p className="mt-8 text-lg text-zinc-300 leading-relaxed max-w-xl">
                                For partnerships, press, XPRIZE-related enquiries, engineering
                                collaborations, or investor conversations — reach out directly.
                            </p>
                        </div>

                        <div className="md:col-span-5 md:pl-8 flex flex-col justify-between gap-8">
                            <div className="space-y-4">
                                <a
                                    href="mailto:garycollins@spectra-em.com?subject=Rane%20Dynamics%20%2F%2F%20Enquiry"
                                    data-testid="contact-email-cta"
                                    className="group flex items-center justify-between gap-4 bg-white/[0.04] hover:bg-[#FF5500] backdrop-blur-xl border border-white/10 rounded-2xl px-6 py-5 transition-all duration-300"
                                >
                                    <div className="min-w-0">
                                        <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 group-hover:text-white/80">
                                            Direct · Gary Collins
                                        </div>
                                        <div className="mt-1 font-display font-bold text-base md:text-lg break-all">
                                            garycollins@spectra-em.com
                                        </div>
                                    </div>
                                    <Mail size={20} className="shrink-0 text-[#FF5500] group-hover:text-white" />
                                </a>

                                <a
                                    href="mailto:garycollins@spectra-em.com?subject=Press%20%2F%2F%20XPRIZE%20Enquiry%20%E2%80%94%20Rane%20Dynamics"
                                    data-testid="contact-press-cta"
                                    className="group flex items-center justify-between gap-4 bg-white/[0.04] hover:bg-white hover:text-zinc-950 backdrop-blur-xl border border-white/10 rounded-2xl px-6 py-5 transition-all duration-300"
                                >
                                    <div className="min-w-0">
                                        <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 group-hover:text-zinc-500">
                                            Press · XPRIZE · Partnerships
                                        </div>
                                        <div className="mt-1 font-display font-bold text-base md:text-lg break-all">
                                            garycollins@spectra-em.com
                                        </div>
                                    </div>
                                    <ArrowRight size={20} className="shrink-0 text-[#FF5500]" />
                                </a>
                            </div>

                            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-zinc-400">
                                <ShieldCheck size={14} className="text-[#FF5500]" />
                                Veteran-founded · Working from the edge
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
